import React, { FunctionComponent } from 'react';

type Props = {
  isPerson: boolean;
  personId?: number | null;
};

export const Presentation: FunctionComponent<Props> = ({
  isPerson,
  personId
}) => {
  return (
    <div className="u-clear">
      <main className="l-main" id="js-l-main" style={{ width: '100%' }}>
        <div className="contact">
          <div className="contact-content">
            <div className="contact-title">お問い合わせ</div>

            {/* ------------------ ユーザー ------------------ */}
            <div className="contentBlock user">
              <p className="contentBlock__subTitle">【ユーザー】</p>
              <div className="contentBlock__contents">

                {/* メール配信停止 */}
                <div className="content-part">
                  <div className="content-sub-title">メール配信停止に関するお問い合わせ</div>
                  <div>
                    {isPerson ? (
                      <p>
                        メールの配信を停止したい方は、
                        <a
                          href={`/users/${personId}/preference/edit`}
                          className="link"
                        >
                          設定ページ
                        </a>
                        から変更してください。
                      </p>
                    ) : (
                      <p>
                        メールの配信を停止したい方は、
                        <a href="/" className="link">
                          ログイン
                        </a>
                        後「設定」から変更してください。
                      </p>
                    )}
                  </div>
                </div>

                {/* サービス問い合わせ */}
                <div className="content-part">
                  <div className="content-sub-title">サービスに関するお問い合わせ</div>
                  <div>
                    <p>
                      よくある質問などを
                      <a
                        href="/mag/guide/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        ユーザーガイド
                      </a>
                      にまとめています。
                    </p>
                    <p>
                      ユーザーガイドをご確認後、解決できない場合は
                      <a
                        href="https://rtf.channel.io/support-bots/70800"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        お問い合わせ
                      </a>
                      ください。
                    </p>
                  </div>
                </div>

              </div>
            </div>

            {/* ------------------ 企業 ------------------ */}
            <div className="contentBlock company">
              <p className="contentBlock__subTitle">【企業】</p>
              <div className="contentBlock__contents">

                {/* 掲載検討中 */}
                <div className="content-part">
                  <div className="content-sub-title">掲載をご検討中の企業</div>
                  <div>
                    <p>
                      サービスの紹介と詳細資料の
                      <a
                        href="https://jinji.readytofashion.jp/service"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        ダウンロードページ
                      </a>
                      をご準備しております。
                    </p>
                    <p>ぜひダウンロードいただき、掲載をご検討ください。</p>
                  </div>
                </div>

                {/* 利用中の企業 */}
                <div className="content-part">
                  <div className="content-sub-title">ご利用中の企業</div>
                  <div>
                    <p>
                      <a
                        href="https://jinji.readytofashion.jp/faq"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        よくある質問
                      </a>
                      をまとめてますのでご確認ください。
                    </p>
                    <p>
                      解決できない場合は企業アカウントに
                      <a
                        href="/hr_login/new"
                        className="link"
                      >
                        ログイン
                      </a>
                      後、画面下部のアイコンからお問い合わせください。
                    </p>
                  </div>
                </div>

                {/* 取材・提案 */}
                <div className="content-part">
                  <div className="content-sub-title">取材や提案などに関するお問い合わせ</div>
                  <div>
                    <p>メールにてお問い合わせください。</p>
                    <p>
                      →<span style={{ fontWeight: 'bold' }}>
                        mail: info@readytofashion.jp
                      </span>
                    </p>
                    <p>※回答にお時間を要する場合がございます。</p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};
